import NewPostModal from './NewPostModal';

export default NewPostModal;
